import React, { useRef, useState } from "react";
import axios from "axios";

import { Button, XClose } from "@opendate-app/setlist";
import "../styles/fanFilterForm.css";
import UserDataForm from "./UserDataForm";
import PurchaseHistoryForm from "./PurchaseHistoryForm";
import SegmentMembershipForm from "./SegmentMembershipForm";
import MessageDataForm from "./MessageDataForm";
import TagDataForm from "./TagDataForm";
import ProductConditionForm from "./ProductConditionForm";
import DonationHistoryForm from "./DonationHistoryForm";
import ContactTypeDataForm from "./ContactTypeDataForm";
import EventViewForm from "./EventViewForm";
import { toastError } from "../../../../shared/toastHelper";
import { trackFilterSave } from "./conditionGate";

const filterRowStyle = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) 36px",
  gap: 8,
  alignItems: "start",
};

const FanFilterForm = (props) => {
  const {
    csrfToken,
    team,
    fanFilterGroup,
    refreshParentGroupState,
    onValidChangeCallback,
  } = props;

  const [fanFilter, setFanFilter] = useState(props.fanFilter);
  // One save at a time: overlapping PUTs can commit out of order, and the
  // older params would then overwrite the newer ones.
  const lastSaveRef = useRef(Promise.resolve());

  const updateFanFilter = (payload) => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    lastSaveRef.current = lastSaveRef.current
      .then(() => axios.put(`/teams/${team.id}/fan_filter_groups/${fanFilterGroup.id}/fan_filters/${fanFilter.id}`, { fan_filter: payload }))
      .then((data) => {
        setFanFilter(data["data"]);
        onValidChangeCallback();
      })
      .catch((error) => {
        toastError((error.response?.data || []).join?.(", ") || "Couldn't save the condition.");
      });
    return trackFilterSave(lastSaveRef.current);
  };

  const deleteFanFilter = () => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    lastSaveRef.current = lastSaveRef.current
      .then(() => axios.delete(`/teams/${team.id}/fan_filter_groups/${fanFilterGroup.id}/fan_filters/${fanFilter.id}`))
      .then(() => {
        refreshParentGroupState();
      })
      .catch((error) => {
        toastError((error.response?.data || []).join?.(", ") || "Couldn't remove the condition.");
      });
    trackFilterSave(lastSaveRef.current);
  };

  return (
    <div className="fan-filter-row" style={filterRowStyle}>
      <div className="fan-filter-fields">
        {fanFilter.type === "FanFilters::UserData" ? (
          <UserDataForm
            fanFilter={fanFilter}
            updateFanFilter={updateFanFilter}
          />
        ) : fanFilter.type === "FanFilters::PurchaseHistory" ? (
          <PurchaseHistoryForm
            fanFilter={fanFilter}
            updateFanFilter={updateFanFilter}
          />
        ) : fanFilter.type === "FanFilters::SegmentMembership" ? (
          <SegmentMembershipForm
            team={team}
            fanFilter={fanFilter}
            updateFanFilter={updateFanFilter}
          />
        ) : fanFilter.type === "FanFilters::MessageData" ? (
          <MessageDataForm
            csrfToken={csrfToken}
            team={team}
            fanFilter={fanFilter}
            updateFanFilter={updateFanFilter}
          />
        ) : fanFilter.type === "FanFilters::TagData" ? (
          <TagDataForm
            team={team}
            fanFilter={fanFilter}
            updateFanFilter={updateFanFilter}
          />
        ) : fanFilter.type === "FanFilters::MembershipData" ? (
          <ProductConditionForm
            fanFilter={fanFilter}
            updateFanFilter={updateFanFilter}
            productsOptionKey="membership_products"
            productIdParam="membership_product_id"
            anyProductLabel="Any membership product"
          />
        ) : fanFilter.type === "FanFilters::PassData" ? (
          <ProductConditionForm
            fanFilter={fanFilter}
            updateFanFilter={updateFanFilter}
            productsOptionKey="series_pass_products"
            productIdParam="series_pass_product_id"
            anyProductLabel="Any flex pack"
          />
        ) : fanFilter.type === "FanFilters::ContactTypeData" ? (
          <ContactTypeDataForm
            fanFilter={fanFilter}
            updateFanFilter={updateFanFilter}
          />
        ) : fanFilter.type === "FanFilters::DonationHistory" ? (
          <DonationHistoryForm
            fanFilter={fanFilter}
            updateFanFilter={updateFanFilter}
          />
        ) : fanFilter.type === "FanFilters::EventView" ? (
          <EventViewForm
            fanFilter={fanFilter}
            updateFanFilter={updateFanFilter}
          />
        ) : null}
      </div>
      <Button
        variant="tertiary"
        icon={XClose}
        aria-label="Remove condition"
        onClick={deleteFanFilter}
      />
    </div>
  );
};

export default FanFilterForm;
